export default __webpack_public_path__ + "static/media/bbb-logo.77743072.png";